import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import React, { useState } from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MenuIcon from "@mui/icons-material/Menu";

function FunnelTierOptions({ id, handleDeleteTier }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleTierDelete = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    handleDeleteTier(id);
  };

  return (
    <>
      <MoreHorizIcon
        sx={{
          p: 0,
          ":hover": {
            cursor: "pointer",
          },
        }}
        onClick={handleClick}
      >
        <MenuIcon />
      </MoreHorizIcon>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleTierDelete}>
          <ListItemIcon>
            <DeleteForeverIcon />
          </ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
            Remove Tier
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}

export default FunnelTierOptions;
